import { deleteCookie, getCookie, setCookie } from "./cookies";
import { initFacebookPixel, trackFacebookPageView } from "@/utils/fbPixel";

export const CONSENT_COOKIE = "rivyou_cookie_consent";
export const CONSENT_ACCEPTED = "accepted";
export const CONSENT_REJECTED = "rejected";
export const COOKIE_PREFERENCES_EVENT = "rivyou:cookie-preferences";

export function getConsent() {
  return getCookie(CONSENT_COOKIE);
}

export function hasConsentChoice() {
  const consent = getConsent();
  return consent === CONSENT_ACCEPTED || consent === CONSENT_REJECTED;
}

export function applyStoredConsent() {
  if (getConsent() === CONSENT_ACCEPTED) {
    initFacebookPixel();
    return true;
  }

  return false;
}

export function acceptMarketingCookies() {
  setCookie(CONSENT_COOKIE, CONSENT_ACCEPTED);
  initFacebookPixel();
  trackFacebookPageView();
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("consent", "grant");
  }
}

export function rejectMarketingCookies() {
  setCookie(CONSENT_COOKIE, CONSENT_REJECTED);
  // If the Meta pixel is already running on this page, stop it sending anything more, and clear the cookies it set.
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("consent", "revoke");
  }
  deleteCookie("_fbp");
  deleteCookie("_fbc");
}

export function openCookiePreferences() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(COOKIE_PREFERENCES_EVENT));
}
